// Angular
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// Component
import { MetricsDashboardComponent } from './metrics-dashboard.component';
import { MetricsToolbarComponent } from './components/table-toolbar/metrics-toolbar.component';
import { WeeklyChartComponent } from './components/weekly-chart/weekly-chart.component';
// Service
import { MetricsDashboardDocumentUnloaderGuard } from './service/guards/metrics-dashboard-unloader.guard';
import { MetricsDashboardDocumentLoaderGuard } from './service/guards/metrics-dashboard-loader.guard';
import { MetricsTableComponent } from './components/metrics-table/metrics-table.component';
import { OrganizationsService } from './service/organizations.service';
import { ProductsService } from './service/products.service';
// Internal Modules
//...
// PrimeNG
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { ReportsService } from './service/reports.service';
import { TooltipModule } from 'primeng/tooltip';
import { MetricsDataService } from './service/metrics-data.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabMenuModule } from 'primeng/tabmenu';

@NgModule({
    imports: [
        TableModule,
        TabMenuModule,
        MultiSelectModule,
        CalendarModule,
        FormsModule,
        ButtonModule,
        TooltipModule,
        CommonModule,
    ],
    exports: [],
    declarations: [
        WeeklyChartComponent,
        MetricsDashboardComponent,
        MetricsTableComponent,
        MetricsToolbarComponent,
    ],
    providers: [
        MetricsDashboardDocumentUnloaderGuard,
        MetricsDashboardDocumentLoaderGuard,
        ReportsService,
        MetricsDataService,
        OrganizationsService,
        ProductsService,
    ],
})
export class MetricsDashboardModule {}
